export default "__VITE_ASSET__D0$lsiE3__"